/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SigninType {
  SMS_OTP = 'SMS_OTP',
  EMAIL_OTP = 'EMAIL_OTP',
}
